import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import AccordionCard from '../../components/AccordionCard';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import '../../HelpCenter.css';
import './Changelog.css';

/**
 * Changelog Category Page
 * Long cards with expandable changelog entries
 */
const Changelog = () => {
  const changelogEntries = [
    {
      question: 'Version 2.1.0 - December 2024',
      answer: (
        <div>
          <p><strong>New Features:</strong></p>
          <ul>
            <li>Added support for multi-currency groups</li>
            <li>Implemented real-time notifications</li>
            <li>Enhanced security with biometric authentication</li>
          </ul>
          <p><strong>Improvements:</strong></p>
          <ul>
            <li>Faster transaction processing</li>
            <li>Improved UI/UX across all platforms</li>
            <li>Better error handling and user feedback</li>
          </ul>
          <p><strong>Bug Fixes:</strong></p>
          <ul>
            <li>Fixed issue with group member invitations</li>
            <li>Resolved transaction history display problems</li>
            <li>Corrected currency conversion calculations</li>
          </ul>
        </div>
      )
    },
    {
      question: 'Version 2.0.5 - November 2024',
      answer: (
        <div>
          <p><strong>New Features:</strong></p>
          <ul>
            <li>Added dark mode support</li>
            <li>Implemented export functionality for transaction history</li>
          </ul>
          <p><strong>Improvements:</strong></p>
          <ul>
            <li>Optimized app performance</li>
            <li>Enhanced group management features</li>
            <li>Improved wallet connection flow</li>
          </ul>
          <p><strong>Bug Fixes:</strong></p>
          <ul>
            <li>Fixed synchronization issues between devices</li>
            <li>Resolved payment processing delays</li>
          </ul>
        </div>
      )
    },
    {
      question: 'Version 2.0.0 - October 2024',
      answer: (
        <div>
          <p><strong>Major Release:</strong></p>
          <ul>
            <li>Complete redesign of the user interface</li>
            <li>New group creation and management system</li>
            <li>Enhanced security features</li>
            <li>Improved mobile app experience</li>
          </ul>
          <p><strong>New Features:</strong></p>
          <ul>
            <li>Recurring expense tracking</li>
            <li>Advanced reporting and analytics</li>
            <li>Integration with popular payment platforms</li>
          </ul>
        </div>
      )
    },
    {
      question: 'Version 1.5.2 - September 2024',
      answer: (
        <div>
          <p><strong>Improvements:</strong></p>
          <ul>
            <li>Enhanced transaction speed</li>
            <li>Better error messages</li>
            <li>Improved accessibility features</li>
          </ul>
          <p><strong>Bug Fixes:</strong></p>
          <ul>
            <li>Fixed issues with group member removal</li>
            <li>Resolved problems with expense splitting calculations</li>
          </ul>
        </div>
      )
    },
    {
      question: 'Version 1.5.0 - August 2024',
      answer: (
        <div>
          <p><strong>New Features:</strong></p>
          <ul>
            <li>Added support for custom expense categories</li>
            <li>Implemented group chat functionality</li>
            <li>Added expense reminders and notifications</li>
          </ul>
          <p><strong>Improvements:</strong></p>
          <ul>
            <li>Streamlined onboarding process</li>
            <li>Enhanced wallet security</li>
          </ul>
        </div>
      )
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">Changelog</h1>
            <p className="lp-section-subtitle">
              Track the latest updates, new features, and improvements.
            </p>
          </header>

          <section className="help-center-categories">
            <div className="changelog-list">
              {changelogEntries.map((entry, index) => (
                <AccordionCard
                  key={index}
                  question={entry.question}
                  answer={entry.answer}
                />
              ))}
            </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Changelog;
